import React from 'react';
import { Field } from 'formik';

import { Grid, InputAdornment } from '@material-ui/core';

import TextFieldFormik from 'app/components/form/formik/TextFieldFormik';
import { AssetHistoryForm } from 'features/equipment/assets/components/equipmentTest/form-utils/AssetHistoryForm';

const CableInsulationFormComponent = () => {
  return (
    <>
      <Grid container>
        <Grid item xs={12} container>
          <Field
            type="number"
            destroyOnUnmount
            label="Resistance"
            component={TextFieldFormik}
            name={AssetHistoryForm.CABLE_INSULATION_TEST_RESISTANCE}
            InputProps={{
              endAdornment: <InputAdornment position="end">giga ohm</InputAdornment>,
            }}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default CableInsulationFormComponent;
